import {InputMode} from 'store/UserInput';

import {afterIncome} from './afterIncome';
import {afterRefill} from './afterRefill';
import {afterSpending} from './afterSpending';

type FutureAmountCalculator = (core: CoreState, input: MoneyAmount) => MoneyAmount;
type HandlersRegistry = Record<InputMode, FutureAmountCalculator>;

export {FutureAmountCalculator};
export function selectHandlerFor(mode: UserInputMode): FutureAmountCalculator {
  const signalHandlers: HandlersRegistry = {
    [InputMode.Spend]: afterSpending,
    [InputMode.Income]: afterIncome,
    [InputMode.Refill]: afterRefill,
  };

  return signalHandlers[mode];
}
